// extracted by mini-css-extract-plugin
export default {"ns_box_radio_label":"NSBoxRadio_ns_box_radio_label__g1ZeG","ns_box_radio_input":"NSBoxRadio_ns_box_radio_input__mKeks"};